






























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import { Tab, Tabs, List, Swipe, SwipeItem } from 'vant';
import ShowList from './components/ShowList.vue';
import ReturnTag from './components/ReturnTag.vue';
import { getLiveList, getVideoList, getTextList } from './api/index';
import { getLiveRunTime } from './ts/common';
Vue.use(Tab)
  .use(Tabs)
  .use(List)
  .use(Swipe)
  .use(SwipeItem);
import * as config from './config';
@Component({
  components: {
    ShowList,
    ReturnTag,
  },
})
export default class ListPage extends Vue {
  public activeNum = 1;
  public List: any[] = [];
  public topList: any[] = [];
  public runTime = {};
  public loading: boolean = false;
  public finished: boolean = false;
  public NoDataImage = [
    'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    'http://image2.cqcb.com/d/file/topics/activity/2019-02-26/P7rEZC4hYS.jpg',
    'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
  ];
  public type?: any;
  public unOpen = false;
  public page = 1;
  public reset() {
    this.page = 1;
    this.loading = false;
    this.finished = false;
    this.List = [];
    // this.topList = [];
  }
  @Watch('$route')
  public onRouteChange() {
    this.reset();
  }
  get swiper() {
    return this.$refs.mySwiper;
  }
  created() {
    this.type = this.$route.query.type;
  }
  onLoad() {
    if (this.type === 1 || this.type === '1') {
      setTimeout(() => {
        getLiveList(this.page).then((res) => this.endListData(res));
      }, 150);
    } else if (this.type === 2 || this.type === '2') {
      setTimeout(() => {
        getVideoList(this.page).then((res) => this.endListData(res));
      }, 150);
    } else if (this.type === 3 || this.type === '3') {
      setTimeout(() => {
        getTextList(this.page).then((res) => this.endListData(res));
      }, 150);
    }
  }
  endListData(res: any) {
    if (this.page === 1) {
      if (res.data.topList.last.length !== 0) {
        (this.topList[0] = res.data.topList.old),
          (this.topList[1] = res.data.topList.self),
          (this.topList[2] = res.data.topList.last);
      } else if (res.data.topList.last.length === 0) {
        (this.topList[0] = res.data.topList.old),
          (this.topList[1] = res.data.topList.self);
      }
      if (res.data.topList.last.start_time) {
        this.runTime = getLiveRunTime(res.data.topList.last.start_time);
      } else {
        this.runTime = getLiveRunTime(res.data.topList.last.createtime);
      }
    }
    if (res.data && res.data.liveList.length > 0) {
      this.page = this.page + 1;
      this.List = [...this.List, ...res.data.liveList];
    } else {
      this.finished = true;
    }
    this.loading = false;
  }
  onClick(index: any) {
    (this.swiper as any).swipeTo(index);
    if (index === 2) {
      (this.$refs.Image as any)[2].style.opacity = 0.5;
      this.unOpen = true;
    } else {
      this.unOpen = false;
    }
  }
  onChange(index: any) {
    this.activeNum = index;
    if (index === 2) {
      (this.$refs.Image as any)[2].style.opacity = 0.5;
      this.unOpen = true;
    } else {
      this.unOpen = false;
    }
  }
  backPath() {
    this.$router.push({
      path: '/20200710SSHD/First',
    });
  }
  enterDetailPage(item: any) {
    if (this.type === 1 || this.type === '1') {
      if (item.start_time * 1000 < new Date().getTime()) {
        if (new Date().getTime() < item.end_time * 1000) {
          this.$router.push({
            name: 'SSHDLiveRoom',
            params: { roomNumber: item.id },
          });
        } else {
          this.$router.push({
            path: '/20200710SSHD/LivePage',
            query: { id: item.id },
          });
        }
      }
    } else if (this.type === 2 || this.type === '2') {
      if (item.createtime * 1000 < new Date().getTime()) {
        this.$router.push({
          path: '/20200710SSHD/VideoPage',
          query: { id: item.id },
        });
      }
    } else if (this.type === 3 || this.type === '3') {
      if (item.createtime * 1000 < new Date().getTime()) {
        this.$router.push({
          path: '/20200710SSHD/TextPage',
          query: { id: item.id },
        });
      }
    }
  }
}
